function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M132.52,90.27c-5.67,1.81-9.09,7.25-7,13.66s8,8.86,13.65,7,9.1-7.25,7.05-13.66S138.19,88.46,132.52,90.27ZM184.2,135.8,247.08,131l-61.9-12,59.26-21.58-62.86,5.11,51.24-36.77L173.67,87.61l39.42-49.23L162,75.4l24.67-58L147.54,66.79l8.1-62.54L131.26,62.41,122.18,0l-7.79,62.58L88.82,4.94,98.2,67.29,58,18.69,83.89,76.2l-51.8-36,40.42,48.4L12.92,68l52,35.71L2,99.88l59.68,20.36L0,133.55l63,3.5L7.2,166.5l61.57-13.62L23,196.28l55.62-29.72L46.29,220.69l45.54-43.63L75.29,237.92l32.07-54.3.49,63.06,16.24-60.93,17.49,60.58-.81-63.05L174,236.9l-17.79-60.5,46.42,42.68-33.45-53.45,56.21,28.57-46.63-42.45,61.84,12.35Zm-42.7-17.43A18.64,18.64,0,1,1,154.07,94.8,18.83,18.83,0,0,1,141.5,118.37Z"
})));

var SvgBurstCircle = function SvgBurstCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 247.08 246.68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurstCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BurstCircle.1ba6bd32.svg";
export { ForwardRef as ReactComponent };